import { render, staticRenderFns } from "./displayIndex.vue?vue&type=template&id=0d342d4a&scoped=true"
import script from "./displayIndex.vue?vue&type=script&lang=js"
export * from "./displayIndex.vue?vue&type=script&lang=js"
import style0 from "./displayIndex.vue?vue&type=style&index=0&id=0d342d4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d342d4a",
  null
  
)

export default component.exports